import { pairingTypes } from "src/modules/pairing/constants";

export default function resolveConfirmationText({
  t,
  deviceName,
  familyName,
  pairingType
}) {
  let textType;
  switch (pairingType) {
    case pairingTypes.INITIAL:
      textType = "initial";
      break;
    case pairingTypes.DEVICES:
      familyName = familyName ? ` (${familyName})` : "";
      textType = "devicesOnly";
      break;
    case pairingTypes.OUR_FAMILY:
    case pairingTypes.OUR_FAMILY_CREATE:
      textType = "ourFamily";
      break;
    case pairingTypes.THEIR_FAMILY:
    case pairingTypes.THEIR_FAMILY_CREATE:
      textType = "theirFamily";
      break;
    default:
      textType = pairingType;
      break;
  }

  return t(`pairing.responder.confirmationDialog.text.${textType}`, {
    value0: deviceName,
    value1: familyName
  });
}
